
export interface PremiumServiceWhatYouGet {
    desc: string,
    points: string[],
}
export interface PremiumServiceKeyBenefit {
    icon?: any,
    text: string,
}
export interface PremiumServiceTestimonial {
    name: string,
    location: string,
    pic: any,
    text: string,
}
export interface PremiumServiceFAQ {
    question: string,
    answer: string,
}
export interface PremiumServiceItem {
    key: string,
    imgSrc: any,
    textAlt: string,
    name: string,
    title: string,
    icon: any,
    shortDescription: string,
    longDescription: string,
    shareDesc: string,
    serviceFee: number,
    keyBenefits: PremiumServiceKeyBenefit[],
    whoIsThisFor: string[],
    whatYouGet?: PremiumServiceWhatYouGet,
    topFeatures?: any[],
    answer?: any[],
    downloadURL: string,
    testimonials?: PremiumServiceTestimonial[],
    faqs: PremiumServiceFAQ[],
    route: string,
    tag: string,
    disclaimer?: string;
}

export const premiumServicesList: PremiumServiceItem[] = [
    {
        key: 'POST_RETIREMENT',
        imgSrc: 'https://docs.turtlemintmoney.com/docs/Post-Retirement.jpg',
        textAlt: 'Post-Retirement',
        name: `Post-Retirement Investment Solution`,
        title: `Post-Retirement Investment Solution`,
        icon: 'post-retirement-investment.svg',
        shortDescription: `Get inflation protected regular income for balanced retired life.`,
        longDescription: `Is your saving enough to take care of your monthly needs post-retirement? How many years will it last for? Our Post-Retirement Investment Solution helps retirees to properly plan their retirement corpus to get inflation protected monthly income after their retirement by investing in a safe mutual funds portfolio.`,
        shareDesc: `Is your saving enough to take care of your monthly needs post-retirement? How many years will it last for? Our Post-Retirement Investment Solution helps retirees to properly plan their retirement corpus to get inflation protected monthly income after their retirement by investing in a safe mutual funds portfolio.`,
        serviceFee: 1999,
        keyBenefits: [{
            icon: `rocket.svg`,
            text: `Earn higher returns compared to fixed deposits and annuity products.`,
        }, {
            icon: `lock.svg`,
            text: `No Lock-in period on your investments, redeem whenever you need it.`,
        }, {
            icon: `fluctuation.svg`,
            text: `Protect investments from market fluctuations.`,
        }, {
            icon: `hourglass.svg`,
            text: `Stretch the payout period on your investments.`,
        }, {
            icon: `shield.svg`,
            text: `Investments payouts are inflation protected.`,
        },],
        whoIsThisFor: [`Senior citizens who have just retired and wish to get regular income for the rest of their life.`, `Individuals who want a safe investment option for their retirement corpus.`, `Investors who are willing to invest at least ₹10 lakhs in our solution.`],
        topFeatures: [`<b>Option A :</b> Get payout of 9.60% per year by investing 70% & 30% of your investments in debt & equity funds respectively`, `<b>Option B :</b> Get payout of 7.50% per year by investing in debt only mutual funds`, `You can choose the frequency of payouts as monthly or quarterly.`, `Choice of investing in mutual funds of leading AMCs`],
        downloadURL: `https://docs.turtlemintmoney.com/docs/TurtlemintPostRetirement.pdf`,
        testimonials: [],
        faqs: [{
            question: `Will I get guaranteed income with the Post Retirement Solution?`,
            answer: `Yes, income is guaranteed by withdrawing from the portfolio at the chosen frequency. This ensures that a fixed income reaches you every month/quarter`,
        }, {
            question: `How long can I get income from this solution?`,
            answer: `Both the Post Retirement Solution options are designed to generate income for an estimated 25 years from the time of investment. The actual tenure of the investment may fluctuate based on returns generated by the debt and/or equity mutual funds based on market conditions.`,
        }, {
            question: `What is the ideal investment period?`,
            answer: `The portfolio has been designed for a longer time horizon so it is recommended that you stay invested for a minimum of 5 years to smooth out any market fluctuations`,
        }, {
            question: `Is there a lock in period?`,
            answer: `No, there is no lock-in period. The balance amount can be fully or partially withdrawn at any time point in time. The actual balance amount may vary based on the past payouts and returns generated by the debt and/or equity mutual funds based on market conditions.`,
        }, {
            question: `Can I track the current value of my portfolio?`,
            answer: `Yes, the portfolio can be tracked on a daily basis from the <b onclick='window.location.href = window.location.origin + "/portfolio"'>customer portfolio details</b> page`,
        }],
        route: 'retirement-income-planning',
        tag: 'mf_post_retirement',
        disclaimer: 'The payout term & investment amount may fluctuate based on market conditions.',
    },
    {
        key: 'CUSTOM_ADVISORY',
        imgSrc: 'https://docs.turtlemintmoney.com/docs/Custom-advisory.jpg',
        textAlt: 'Custom-advisory',
        name: `Custom Portfolio Rebalance Solution`,
        title: `Custom Portfolio Rebalance Solution`,
        icon: 'custom-portfolio-rebalance.svg',
        shortDescription: `Consult experts to analyse and rebalance your investments`,
        longDescription: `Custom Portfolio Rebalance Solution allows you to consult experts on your existing mutual fund portfolio and  receive recommendations to meet your life goals.`,
        shareDesc: `Are you not satisfied with returns on your investment portfolio? Our Custom Portfolio Rebalance Solution allows you to consult experts on your existing mutual fund portfolio. In this you will receive complete assessment of your investments and recommendations to achieve your financial goals.`,
        serviceFee: 1999,
        keyBenefits: [{
            icon: 'briefcase.svg',
            text: `Reduces the clutter of non-performing mutual funds by diverting investments in better performing mutual funds.`,
        }, {
            icon: 'target.svg',
            text: `Aligns portfolio investments with risk profile and investment horizon.`,
        }, {
            icon: 'star.svg',
            text: `Get new recommendations which are specially designed to achieve your future financial goals.`,
        }],
        whoIsThisFor: [`Investor who has an existing mutual funds portfolio or wants to invest at least ₹ 10 lakhs.`],
        whatYouGet: {
            desc: `Our industry experts will personally consult with you to understand your requirements and at the end you will receive a comprehensive investment report which will consist of:`,
            points: [`Assessment of your risk profile`, `Recommendations to exit under-performing mutual funds`, `Mutual funds recommendations matching your financial goals`],
        },
        downloadURL: 'https://docs.turtlemintmoney.com/docs/CustomAdvisory.pdf',
        testimonials: [],
        faqs: [{
            question: `Do I need any existing investments?`,
            answer: `Not necessary. Custom Advisory can also be availed for a fresh investment for a minimum value of Rs 10 lakhs. The advice will be tailored to specific requirements of the client`,
        }, {
            question: `Should my existing investments be invested with Turtlemint Money?`,
            answer: `No. The Custom Advisory Solution can be availed for investments made on any platform. After reviewing the advice, the client has an option to move their investments to Turtlemint Money.`,
        }, {
            question: `Will it cost additional money to move existing investments to TM Money?`,
            answer: `Capital gains tax on realised gains and Securities Transaction Tax(STT) on the sell and buy value of  investments are the only taxes payable by the investor. No fees are charged by Turtlemint Money.`,
        }, {
            question: `What are some reasons to avail this Solution?`,
            answer: `Custom Advisory can be used to improve performance of your existing portfolio by weeding out non-performing schemes, aligning your portfolio with your risk profile and ensuring you can meet your investment goals.`,
        }, {
            question: `How often will my portfolio be reviewed?`,
            answer: `An annual portfolio review will be conducted and if necessary, rebalancing and restructuring will be done`,
        }],
        route: 'custom-portfolio-review',
        tag: 'mf_custom_advisory',
    },
    {
        key: 'CORPORATE_TREASURY',
        imgSrc: 'https://docs.turtlemintmoney.com/docs/Company-funds-investment-solution.png',
        textAlt: 'Compay-Funds',
        name: `Company Funds Investment Solution`,
        title: `Company Funds Investment Solution`,
        icon: 'company-funds-investment-solution.svg',
        shortDescription: `Invest your company’s funds to generate better returns than bank fixed deposit`,
        longDescription: `Do you want to invest your company’s surplus funds in a low risk instrument for short term? We have designed investment products for small scale enterprises & corporates to generate better returns than bank fixed deposit while saving taxes.`,
        shareDesc: `Are you not satisfied with returns on your investment portfolio? Our Company Funds Investment Solution allows you to consult experts on your existing mutual fund portfolio. In this you will receive complete assessment of your investments and recommendations to achieve your financial goals.`,
        serviceFee: 1999,
        keyBenefits: [{
            icon: 'fluctuation.svg',
            text: `Investment are done in debt funds which are safer than equity funds`,
        }, {
            icon: 'withdraw-icon.svg',
            text: `Flexibility to withdraw funds as per your operational requirements.`,
        }, {
            icon: 'tax-icon.svg',
            text: `Save on tax liabilities untill your investments are redeemed`,
        }, {
            icon: `shield.svg`,
            text: `Protection against interest rate risk which enables smooth & stable returns`,
        }, {
            icon: `hourglass.svg`,
            text: `Decide fund distribution based on liquidity needs over the course of investment period`,
        }],
        whoIsThisFor: [
            `Corporates & small business owners who wish to get better returns on their short term investments`,
            `Charter accountants or financial officers who manage funds for small scale enterprises.`,
        ],
        whatYouGet: {
            desc: ``,
            points: [
                `Investments are made in debt mutual fund of more that 90% AAA credit quality.`, 
                `Investment solutions are rated 5 stars by Morning star ratings`, 
                `Investments are done in funds of various maturities ranging from 3 months to 1+ years to ensure you have intermittent liquidity available for your company's operational costs`],
        },
        downloadURL: 'https://docs.turtlemintmoney.com/docs/Company+Funds+Investment+Service.pdf',
        testimonials: [],
        faqs: [{
            question: `How much control will I have?`,
            answer: `Once the investment has been made, funds can be withdrawn based on client needs at any time.`,
        }, {
            question: `Will I get guaranteed income?`,
            answer: `While income is not guaranteed in mutual funds, debt funds are considerably safer than equity funds and recommended funds have good ratings and performance history.`,
        }, {
            question: `Can I choose the product to invest in?`,
            answer: `Apart from our top recommended custom portfolio, every client has the option to choose from an alternative list of funds should they wish to do so.`,
        }],
        route: 'company-funds-investment',
        tag: 'mf_corporate_treasury',
    }
];